import React, { createContext, useContext } from 'react';
import { useVisitorAnalytics, VisitorData } from '../hooks/useVisitorAnalytics';
interface AnalyticsContextType {
  visitorData: VisitorData | null;
  trackPageVisit: (pageName: string) => void;
  trackSectionView: (sectionName: string) => void;
  trackChatInteraction: () => void;
  trackFileUpload: () => void;
  updateUserInfo: (name: string, role: string, firm: string) => void;
  exportAnalytics: () => string;
  sendAnalyticsToServer: (endpoint: string) => Promise<void>;
}
const AnalyticsContext = createContext<AnalyticsContextType | undefined>(undefined);
export const AnalyticsProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const analytics = useVisitorAnalytics();
  return <AnalyticsContext.Provider value={analytics} data-id="element-1435">
      {children}
    </AnalyticsContext.Provider>;
};
export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};